// Royal Tadka — official menu (source: restaurant's printed menu)
export const MENU_CATEGORIES = [
    {
        id: "starters",
        title: "Starters",
        desc: "Crisp beginnings from the fryer and the tandoor.",
        dishes: [
            { name: "Chicken Samosa", desc: "", veg: false, price: 22, img: "samosa" },
            { name: "Aloo Samosa", desc: "", veg: true, price: 18, img: "samosaPlate" },
            { name: "Mixed Pakora", desc: "", veg: true, price: 22, img: "skewers" },
            { name: "Paneer Pakora", desc: "", veg: true, price: 24, img: "chickenTikkaPlate" },
            { name: "Chicken Pakora", desc: "", veg: false, price: 26, img: "tandooriChicken" },
            { name: "Prawn Pakora", desc: "", veg: false, price: 34, img: "fishCurry" },
        ],
    },
    {
        id: "salad-raita",
        title: "Salad & Raita",
        desc: "Fresh, cooling companions.",
        dishes: [
            { name: "Mixed Veg Raita", desc: "", veg: true, price: 12, img: "raita" },
            { name: "Green Salad", desc: "", veg: true, price: 15, img: "saladBowl" },
            { name: "Chicken Tikka Salad", desc: "", veg: false, price: 25, img: "tandooriLegs" },
            { name: "Paneer Salad", desc: "", veg: true, price: 22, img: "paneerRice" },
            { name: "Aloo Chana Chat", desc: "", veg: true, price: 26, img: "chaat" },
            { name: "Samoosa Chat", desc: "", veg: true, price: 26, img: "samosaPlate" },
        ],
    },
    {
        id: "soups",
        title: "Soups",
        desc: "Warm, gently spiced.",
        dishes: [
            { name: "Dal Soup", desc: "", veg: true, price: 18, img: "soupOrange" },
            { name: "Tomato Soup", desc: "", veg: true, price: 20, img: "soupTomato" },
            { name: "Chicken Soup", desc: "", veg: false, price: 22, img: "soupCream" },
            { name: "Prawn Soup", desc: "", veg: false, price: 26, img: "soupTomato" },
        ],
    },
    {
        id: "vegetarian-curry",
        title: "Vegetarian Curry",
        desc: "Slow-cooked classics from the Indian kitchen.",
        dishes: [
            { name: "Cheese Paneer Butter Masala", desc: "", veg: true, price: 34, img: "paneerMasala" },
            { name: "Paneer Tikka Masala", desc: "", veg: true, price: 35, img: "paneerRice", popular: true },
            { name: "Paneer Kadai", desc: "", veg: true, price: 34, img: "curryPan" },
            { name: "Paneer Korma", desc: "", veg: true, price: 36, img: "curryHero" },
            { name: "Paneer Lababdar", desc: "", veg: true, price: 36, img: "tikkaMasala" },
            { name: "Rajma Masala", desc: "", veg: true, price: 30, img: "chickenPan" },
            { name: "Dal Tadka", desc: "", veg: true, price: 32, img: "soupOrange" },
            { name: "Chana Masala", desc: "", veg: true, price: 32, img: "curryPan" },
        ],
    },
    {
        id: "chicken-curry",
        title: "Chicken Curry",
        desc: "From creamy and mild to boldly spiced.",
        dishes: [
            { name: "Butter Chicken", desc: "", veg: false, price: 38, img: "butterChicken", popular: true },
            { name: "Chicken Tikka Masala", desc: "", veg: false, price: 38, img: "tikkaMasala", popular: true },
            { name: "Mango Chicken", desc: "", veg: false, price: 38, img: "chickenPot" },
            { name: "Chicken Korma", desc: "", veg: false, price: 38, img: "curryHero" },
            { name: "Chicken Kadai", desc: "", veg: false, price: 38, img: "chickenPan", spicy: 2 },
            { name: "Chicken Jalfrezi", desc: "", veg: false, price: 38, img: "chickenTikkaPlate", spicy: 2 },
            { name: "Chicken Palak", desc: "", veg: false, price: 38, img: "palakPaneer" },
            { name: "Chicken Madras", desc: "", veg: false, price: 38, img: "curryBread", spicy: 2 },
            { name: "Chicken Lababdar", desc: "", veg: false, price: 38, img: "chickenPot" },
            { name: "Chicken Vindaloo", desc: "", veg: false, price: 38, img: "chickenPan", spicy: 3 },
        ],
    },
    {
        id: "lamb-curry",
        title: "Lamb Curry",
        desc: "Deep, slow-braised flavours.",
        dishes: [
            { name: "Lamb Curry", desc: "", veg: false, price: 38, img: "lambCurry" },
            { name: "Lamb Rogan Josh", desc: "", veg: false, price: 40, img: "lambCurry" },
            { name: "Lamb Kadai", desc: "", veg: false, price: 42, img: "chickenPan", spicy: 2 },
            { name: "Lamb Mango", desc: "", veg: false, price: 42, img: "chickenPot" },
            { name: "Lamb Korma", desc: "", veg: false, price: 44, img: "butterChicken" },
            { name: "Lamb Palak", desc: "", veg: false, price: 42, img: "palakPaneer" },
            { name: "Lamb Madras", desc: "", veg: false, price: 42, img: "curryPan", spicy: 2 },
            { name: "Lamb Tikka Masala", desc: "", veg: false, price: 42, img: "tikkaMasala" },
            { name: "Butter Lamb", desc: "", veg: false, price: 42, img: "butterChicken" },
        ],
    },
    {
        id: "tandoor",
        title: "Tandoor Dishes",
        desc: "Seared in the traditional clay oven.",
        dishes: [
            { name: "Tandoori Chicken", desc: "", veg: false, price: 38, img: "tandooriLegs", popular: true },
            { name: "Malai Chicken", desc: "", veg: false, price: 42, img: "tandooriChicken" },
            { name: "Chicken Tikka", desc: "", veg: false, price: 38, img: "skewers" },
            { name: "Prawns Tikka", desc: "", veg: false, price: 40, img: "mixedGrill" },
        ],
    },
    {
        id: "bread",
        title: "Indian Bread",
        desc: "Baked to order against the tandoor's clay walls.",
        dishes: [
            { name: "Roti", desc: "", veg: true, price: 10, img: "thaliParatha" },
            { name: "Plain Nan", desc: "", veg: true, price: 12, img: "naanBasket" },
            { name: "Butter Nan", desc: "", veg: true, price: 14, img: "rollsCurry" },
            { name: "Garlic Nan", desc: "", veg: true, price: 14, img: "curryBread" },
            { name: "Peshawari Nan", desc: "", veg: true, price: 15, img: "naanBasket" },
            { name: "Cheese Nan", desc: "", veg: true, price: 15, img: "rollsCurry" },
            { name: "Aloo Parota", desc: "", veg: true, price: 15, img: "thaliParatha" },
            { name: "Lacha Parata", desc: "", veg: true, price: 14, img: "thaliParatha" },
            { name: "Amritsari Kulcha", desc: "", veg: true, price: 19, img: "rollsCurry" },
        ],
    },
    {
        id: "rice-biryani",
        title: "Rice & Biryani",
        desc: "Fragrant basmati, layered and aromatic.",
        dishes: [
            { name: "Plain Basmati Rice", desc: "", veg: true, price: 10, img: "biryaniBowls" },
            { name: "Jeera Rice", desc: "", veg: true, price: 14, img: "riceVeg" },
            { name: "Veg Palou", desc: "", veg: true, price: 18, img: "friedRice" },
            { name: "Chicken Biryani", desc: "", veg: false, price: 36, img: "biryaniChicken", popular: true },
            { name: "Lamb Biryani", desc: "", veg: false, price: 44, img: "biryaniLamb" },
            { name: "Prawns Biryani", desc: "", veg: false, price: 40, img: "biryani" },
            { name: "Vegetable Biryani", desc: "", veg: true, price: 32, img: "biryaniClay" },
            { name: "Lemon Rice", desc: "", veg: true, price: 16, img: "riceVeg" },
        ],
    },
    {
        id: "kati-roll",
        title: "Kati Roll — Veg & Chicken",
        desc: "Kolkata-style street rolls.",
        dishes: [
            { name: "Paneer Kati Roll", desc: "", veg: true, price: 22, img: "samosaPlate" },
            { name: "Chicken Kati Roll", desc: "", veg: false, price: 25, img: "rollsCurry" },
            { name: "Mutton Kati Roll", desc: "", veg: false, price: 38, img: "skewersFries" },
        ],
    },
    {
        id: "fish",
        title: "Fish Curry",
        desc: "Coastal-style preparations.",
        dishes: [
            { name: "Fish Madras", desc: "", veg: false, price: 48, img: "fishCurry", spicy: 2 },
            { name: "Fish Vindaloo", desc: "", veg: false, price: 48, img: "fishCurry", spicy: 3 },
        ],
    },
    {
        id: "indo-chinese",
        title: "Indo Chinese",
        desc: "Wok-tossed Indo-Chinese favourites.",
        dishes: [
            { name: "Chicken Chilli", desc: "", veg: false, price: 34, img: "chickenPan", spicy: 2 },
            { name: "Chicken 65", desc: "", veg: false, price: 36, img: "tandooriChicken", spicy: 2 },
            { name: "Paneer Chilli", desc: "", veg: true, price: 32, img: "paneerRice", spicy: 2 },
            { name: "Vegetable Fried Rice", desc: "", veg: true, price: 30, img: "riceVeg" },
            { name: "Chicken Fried Rice", desc: "", veg: false, price: 34, img: "friedRice" },
            { name: "Egg Fried Rice", desc: "", veg: false, price: 32, img: "biryaniBowls" },
            { name: "Chicken Noodles", desc: "", veg: false, price: 35, img: "noodlesChop" },
            { name: "Prawn Noodles", desc: "", veg: false, price: 38, img: "noodles" },
            { name: "Vegetable Noodles", desc: "", veg: true, price: 32, img: "noodles" },
        ],
    },
    {
        id: "drinks",
        title: "Drinks",
        desc: "Lassis, chai and refreshments.",
        dishes: [
            { name: "Mango Lassi", desc: "", veg: true, price: 12, img: "mangoLassi", popular: true },
            { name: "Jeera Salt Lassi", desc: "", veg: true, price: 12, img: "lassiPink" },
            { name: "Sweet Lassi", desc: "", veg: true, price: 12, img: "lassiPink" },
            { name: "Pepsi", desc: "", veg: true, price: 10, img: "softDrink" },
            { name: "Fanta", desc: "", veg: true, price: 10, img: "softDrink" },
            { name: "Lipton Peach", desc: "", veg: true, price: 10, img: "softDrink" },
            { name: "Water Naturalny", desc: "", veg: true, price: 6, img: "water" },
            { name: "Indian Masala Tea", desc: "", veg: true, price: 10, img: "chai" },
            { name: "Black Coffee", desc: "", veg: true, price: 8, img: "coffee" },
            { name: "Coconut Lassi", desc: "", veg: true, price: 14, img: "mangoLassi" },
        ],
    },
    {
        id: "desserts",
        title: "Desserts",
        desc: "A gentle, sweet ending.",
        dishes: [
            { name: "Gulab Jamun", desc: "", veg: true, price: 16, img: "gulabJamun", popular: true },
            { name: "Rice Kheer", desc: "", veg: true, price: 12, img: "soupCream" },
            { name: "Carrot Halwa", desc: "", veg: true, price: 12, img: "dessertCaramel" },
        ],
    },
];

export const ALL_DISHES = MENU_CATEGORIES.flatMap((c) =>
    c.dishes.map((d) => ({ ...d, category: c.title, categoryId: c.id })),
);

